import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import * as styles from "./styles.module.scss";

const Footer = ( { variant = "dark" } ) => (
	<footer className={ classNames( styles.footer, styles[ variant ] ) }>
		<p>
			<a target="_blank" rel="noopener noreferrer" href="https://yoast.com/reserved-rights/">Some rights reserved</a>
			<a target="_blank" rel="noopener noreferrer" href="https://newfold.com/privacy-center/privacy">Privacy notice</a>
			<a target="_blank" rel="noopener noreferrer" href="https://yoast.com/terms-of-service/">Terms of service</a>
			<a target="_blank" rel="noopener noreferrer" href="https://legal.newfold.com/TermsOfUse.pdf">Terms of use</a>
			<a target="_blank" rel="noopener noreferrer" href="https://newfold.com/privacy-center/cookie-policy">Cookie notice</a>
			<a target="_blank" rel="noopener noreferrer" href="https://yoast.com/terms-of-service/#h-yoast-refund-policy">Refund policy</a>
			<a target="_blank" rel="noopener noreferrer" href="https://yoast.com/review-notice/">Review notice</a>
			<a target="_blank" rel="noopener noreferrer" href="https://www.newfold.com/abuse">Report abuse</a>
			<a target="_blank" rel="noopener noreferrer" href="https://yoast.com/contact/">Contact us</a>
			<a target="_blank" rel="noopener noreferrer" href="https://www.newfold.com/privacy-center/addendum-for-california-users">Do not sell or share my personal information</a>
		</p>
		<p>
			&copy; 2003-{ new Date().getFullYear() } <strong className={ styles.trademark }>Yoast BV</strong> Yoast is a trademark of Yoast BV
		</p>
	</footer>
);

Footer.propTypes = {
	variant: PropTypes.oneOf( [ "dark", "light" ] ),
};

export default Footer;
